import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TruckXs from 'src/Images/icons/truck/truck-xs.png';
import TruckSm from 'src/Images/icons/truck/truck-sm.png';
import TruckMd from 'src/Images/icons/truck/truck-md.png';
import TruckLg from 'src/Images/icons/truck/truck-lg.png';
import TruckXl from 'src/Images/icons/truck/truck-xl.png';
import { ReactComponent as LoadingImage } from 'src/Images/icons/vehicle-tracking/loading-image.svg';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function CurrentVehicleTracking({ colSize }) {
  const navigate = useNavigate();
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );
  const { stationData } = vehicleTrackingDataReducer;

  const moveToVehicleTrackingDetailPage = (
    workflowStageId,
    vehicleTrackingNumber,
  ) => {
    navigate(`/${workflowStageId}/${vehicleTrackingNumber}`);
  };

  return (
    <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={12}>
      {stationData?.currentVehicleTracking && (
        <Row className="rg-20">
          {stationData?.currentVehicleTracking?.count > 0 ? (
            stationData?.currentVehicleTracking?.data.map((data) => (
              <Col
                xxl={colSize}
                xl={colSize}
                lg={6}
                md={6}
                sm={12}
                xs={12}
                key={data.vehicle_tracking_number}
              >
                <div className="vehicle-tracking-card-height vehicle-tracking-card-container">
                  <div className="vehicle-tracking-card-container-label div-flex-row cg-10">
                    <div className="vehicle-tracking-pill-green">
                      <span className="text-sm">
                        {data.vehicle_tracking_code}
                      </span>
                    </div>
                    <div className="vehicle-tracking-pill-blue">
                      <span className="text-sm">{data.workflow}</span>
                    </div>
                    {data.is_load_attached && (
                      <div className="vehicle-tracking-pill-grey">
                        <LoadingImage className="icon-size-lg" />
                      </div>
                    )}
                  </div>
                  <div className="vehicle-tracking-card-container-detail div-flex-column rg-5">
                    <div className="div-flex-row cg-5 div-align-center">
                      <div
                        className={data.stage1 ? 'timeline-point left' : ''}
                      />
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="timeline-line" />
                      </Col>
                      <div className="timeline-point" />
                    </div>
                    <Row>
                      <Col
                        xxl={6}
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className="border-right"
                      >
                        {data.stage1 && (
                          <div className="div-flex-column">
                            <span className="text-lg text-bold">
                              {data.stage1?.workflow_stage_name}
                            </span>
                            <span className="text-md">
                              {data.stage1?.timestamp}
                            </span>
                            <span className="text-md">
                              {data.stage1?.timestamp_string}.
                            </span>
                          </div>
                        )}
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="div-flex-column">
                          <span className="text-lg text-bold">
                            {data.stage2?.workflow_stage_name}
                          </span>
                          <span className="text-md">
                            Estimated {data.stage2?.timestamp}.
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        {data.vehicle_type === '1' ? (
                          <img
                            src={TruckXs}
                            alt="truck"
                            className="icon-size-truck"
                          />
                        ) : data.vehicle_type === '2' ? (
                          <img
                            src={TruckSm}
                            alt="truck"
                            className="icon-size-truck"
                          />
                        ) : data.vehicle_type === '3' ? (
                          <img
                            src={TruckMd}
                            alt="truck"
                            className="icon-size-truck"
                          />
                        ) : data.vehicle_type === '4' ? (
                          <img
                            src={TruckLg}
                            alt="truck"
                            className="icon-size-truck"
                          />
                        ) : (
                          <img
                            src={TruckXl}
                            alt="truck"
                            className="icon-size-truck"
                          />
                        )}
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="vehicle-tracking-card-vehicle-number">
                          <button
                            className="icon-btn-none"
                            onClick={() =>
                              moveToVehicleTrackingDetailPage(
                                data.stage2.workflow_stage_id,
                                data.vehicle_tracking_number,
                              )
                            }
                          >
                            <span className="text-xl text-underline text-bold">
                              {data.vehicle_number}
                            </span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col>
              <span className="text-md text-grey text-bold">
                No vehicle available
              </span>
            </Col>
          )}
        </Row>
      )}
    </Col>
  );
}
